import React from 'react';
import AppHeader from '@active/react-ui/AppHeader';
import Logo from './logo.svg';

const Header = () => <AppHeader theme="dark" logo={<img src={Logo} alt="logo" />} />;

export default Header;
